// import $ from 'jquery';
import {Controller} from "stimulus";
import {fetchJson} from "../assets/request";
import eventProxy from "../assets/event-proxy";
import translate from "../assets/translate";
import {objectToFormData} from "../assets/forms";
import {getVideoDuration, getFileHash, scaleDownImage, getImageSize} from "../assets/utils";

export default class extends Controller {
  connect() {
    this.error_messages = [];
    this.machine_id = parseInt(this.element.dataset.machineId);
    this.videoMaxLength = 0;
    this.uploadType = this.element.dataset?.uploadType ?? 'image';

    import ( /* webpackChunkName: 'fileuploader' */ "../assets/fileuploader").then(({default: fileuploader}) => {
      this.fileuploader = fileuploader;

      const inputEl = window.$(this.element);
      // inputEl.on("fileuploader:thumbnails:onImageLoaded", (proxy, ...args) => this.thumbnailsOnImageLoaded(...args));
      inputEl.on("fileuploader:thumbnails:onItemShow", (proxy, ...args) => this.thumbnailsOnItemShow(...args));
      inputEl.on("fileuploader:thumbnails:onItemRemove", (proxy, ...args) => this.thumbnailsOnItemRemove(...args));
      inputEl.on("fileuploader:upload:beforeSend", (proxy, ...args) => this.uploadBeforeSend(...args));
      inputEl.on("fileuploader:upload:onSuccess", (proxy, ...args) => this.uploadOnSuccess(...args));
      inputEl.on("fileuploader:upload:onError", (proxy, ...args) => this.uploadOnError(...args));
      inputEl.on("fileuploader:upload:onProgress", (proxy, ...args) => this.uploadOnProgress(...args));
      inputEl.on("fileuploader:upload:onComplete", (proxy, ...args) => this.uploadOnComplete(...args));
      inputEl.on("fileuploader:sorter:onSort", (proxy, ...args) => this.sorterOnSort(...args));
      inputEl.on("fileuploader:editor:onSave", (proxy, ...args) => this.editorOnSave(...args));
      // inputEl.on("fileuploader:dragDrop:onDragEnter", (proxy, ...args) => this.dragDropOnDragEnter(...args));
      // inputEl.on("fileuploader:dragDrop:onDragLeave", (proxy, ...args) => this.dragDropOnDragLeave(...args));
      // inputEl.on("fileuploader:dragDrop:onDrop", (proxy, ...args) => this.dragDropOnDrop(...args));
      // inputEl.on("fileuploader:onSupportError", (proxy, ...args) => this.onSupportError(...args));
      // inputEl.on("fileuploader:beforeRender", (proxy, ...args) => this.beforeRender(...args));
      inputEl.on("fileuploader:afterRender", (proxy, ...args) => this.afterRender(...args));
      // inputEl.on("fileuploader:beforeSelect", (proxy, ...args) => this.beforeSelect(...args));
      // inputEl.on("fileuploader:onFilesCheck", (proxy, ...args) => this.onFilesCheck(...args));
      // inputEl.on("fileuploader:onFileRead", (proxy, ...args) => this.onFileRead(...args));
      inputEl.on("fileuploader:onSelect", (proxy, ...args) => this.onSelect(...args));
      // inputEl.on("fileuploader:afterSelect", (proxy, ...args) => this.afterSelect(...args));
      // inputEl.on("fileuploader:onListInput", (proxy, ...args) => this.onListInput(...args));
      inputEl.on("fileuploader:onRemove", (proxy, ...args) => this.onRemove(...args));
      // inputEl.on("fileuploader:onEmpty", (proxy, ...args) => this.onEmpty(...args));

      if (this.api === void 0) {
        const options = {
          upload: {
            url: this.base_url,
            chunk: 4,
            start: false, // upload nicht automatisch starten, damit asynchrone tasks ausgeführt werden können.
            data: {
              machine_id: this.machine_id,
              imageType: this.element.dataset.imageType || null,
              type: "upload"
            }
          }
        };
        if (this.element.dataset.language && window.$.fn.fileuploader.languages[this.element.dataset.language] !== void 0) {
          options.captions = this.element.dataset.language;
        }
        if (this.data.get('video-max-length')) {
          this.videoMaxLength = parseFloat(this.data.get('video-max-length')) || 0;
        }
        if (options.upload.data.imageType === 'panorama') {
          options.thumbnails = {
            popup: {
              onShow: function (item) {
                item.popup.html
                  .on('click', '[data-action="cancel"]', function (e) {
                    item.popup.close();
                  })
              },
              template: panoramaTemplate
            },
          }
        }
        inputEl.fileuploader(options);
      }
    });
  }

  get base_url() {
    return "/offer/image/fileuploader/";
  }

  disconnect() {
    const inputEl = window.$(this.element);
    // inputEl.off("fileuploader:thumbnails:onImageLoaded");
    inputEl.off("fileuploader:thumbnails:onItemShow");
    inputEl.off("fileuploader:thumbnails:onItemRemove");
    inputEl.off("fileuploader:upload:beforeSend");
    inputEl.off("fileuploader:upload:onSuccess");
    inputEl.off("fileuploader:upload:onError");
    inputEl.off("fileuploader:upload:onProgress");
    inputEl.off("fileuploader:upload:onComplete");
    inputEl.off("fileuploader:sorter:onSort");
    inputEl.off("fileuploader:editor:onSave");
    // inputEl.off("fileuploader:dragDrop:onDragEnter");
    // inputEl.off("fileuploader:dragDrop:onDragLeave");
    // inputEl.off("fileuploader:dragDrop:onDrop");
    // inputEl.off("fileuploader:onSupportError");
    // inputEl.off("fileuploader:beforeRender");
    inputEl.off("fileuploader:afterRender");
    // inputEl.off("fileuploader:beforeSelect");
    // inputEl.off("fileuploader:onFilesCheck");
    // inputEl.off("fileuploader:onFileRead");
    inputEl.off("fileuploader:onSelect");
    // inputEl.off("fileuploader:afterSelect");
    // inputEl.off("fileuploader:onListInput");
    inputEl.off("fileuploader:onRemove");
    // inputEl.off("fileuploader:onEmpty");
  }

  get limit_reached() {
    const limit_reached = this.api.getOptions().limit && this.api.getFileList().length >= this.api.getOptions().limit;
    return limit_reached;
  }

  get api() {
    return this.fileuploader && this.fileuploader.getInstance(this.element) || void 0;
  }

  ajaxCall(data) {
    return fetchJson(this.base_url, {
      method: 'POST',
      body: objectToFormData(data)
    })
  }

  // thumbnailsOnImageLoaded(item, listEl, parentEl, newInputEl, inputEl) {
  // }

  thumbnailsOnItemShow(item, listEl, parentEl, newInputEl, inputEl) {
    const plusInput = listEl.find('.fileuploader-thumbnails-input');
    plusInput.insertAfter(item.html);
  }

  thumbnailsOnItemRemove(html, listEl, parentEl, newInputEl, inputEl) {
    html.remove();
  }

  uploadBeforeSend(item, listEl, parentEl, newInputEl, inputEl) {
    if (item.data) {
      Object.assign(item.upload.data, item.data);
    }
  }


  uploadOnSuccess(data, item, listEl, parentEl, newInputEl, inputEl, textStatus, jqXHR) {
    item.data = data;
    item.html.find('.progress-holder').fadeOut(400);
    eventProxy.emit("update-completeness-index");
  }

  uploadOnError(item, listEl, parentEl, newInputEl, inputEl, jqXHR, textStatus, errorThrown) {
    let delay = 1000;
    if (item.upload.status === "canceled") {
      delay = 0;
    }
    console.error('Fileuploader:onUploadError', JSON.stringify({
      'textStatus': textStatus,
      'errorThrown': errorThrown,
      "machine_id": this.machine_id,
      "response": jqXHR.responseText,
      "statusCode": jqXHR.status,
      "item.name": item.name,
      "item.upload.status": item.upload.status,
      "item.file.name": item.file.name,
      "item.file.size": item.file.size,
    }, null, 4));
    item.html.find('.progress-holder').hide();
    if (jqXHR.responseJSON) {
      if (jqXHR.responseJSON.warnings && Array.isArray(jqXHR.responseJSON.warnings)) {
        jqXHR.responseJSON.warnings.forEach((message) => {
          this.error_messages.push({
            file: item.name,
            message: message
          });
        });
      }
      if (jqXHR.responseJSON.message) {
        this.error_messages.push({
          file: item.name,
          message: jqXHR.responseJSON.message
        });
      }
    } else if (textStatus || errorThrown) {
      // Übertragungsfehler
      this.error_messages.push({
        file: item.name,
        message: [textStatus, errorThrown].filter(i => i).join(": ")
      });
    }
    setTimeout(() => this.api.remove(item), delay);
  }

  uploadOnProgress(data, item, listEl, parentEl, newInputEl, inputEl) {
    var progressBar = item.html.find('.progress-holder');
    if (progressBar.length > 0) {
      progressBar.show();
      progressBar.find('.bar').width(data.percentage + "%");
    }
  }

  uploadOnComplete(listEl, parentEl, newInputEl, inputEl, jqXHR, textStatus) {
    eventProxy.emit("update-completeness-index");
    if (this.error_messages.length > 0) {
      let message = this.error_messages.map(function (item) {
        return [item.file, item.message].join(": ");
      }).join("\n");
      this.error_messages = [];
      setTimeout(() => alert(message), 300);
    }
    this.sorterOnSort(this.api.getFiles(), listEl, parentEl, newInputEl, inputEl);
  }

  sorterOnSort(list, listEl, parentEl, newInputEl, inputEl) {
    let file_type = 'pictures'
    const file_ids = list
      .map(function (item) {
        if(item.data.file_id)
        {
          return item.data.file_id
        }

        if(item.data.id)
        {
          file_type = 'videos'
          return Number(item.data.id)
        }

      })
      .filter(Number.isInteger);

    if (file_ids.length === 0) {
      return false;
    }
    return this.ajaxCall({
      machine_id: this.machine_id,
      file_ids: file_ids,
      file_type: file_type,
      type: "sort"
    });
  }

  editorOnSave(blobOrDataUrl, item, listEl, parentEl, newInputEl, inputEl) {
    item.data.rotation = (item.data.rotation || 0);
    if (item.data.rotation != item.editor.rotation) {
      var delta = item.editor.rotation - item.data.rotation;
      delta = -Math.max(delta, (delta + 360)) % 360;
      item.data.rotation = item.editor.rotation;
      return this.ajaxCall({
        machine_id: this.machine_id,
        file_id: item.data.file_id,
        type: "rotate",
        rotation: delta
      });
    }
  }

  // dragDropOnDragEnter(event, listEl, parentEl, newInputEl, inputEl) {
  //     return true;
  // }

  // dragDropOnDragLeave(event, listEl, parentEl, newInputEl, inputEl) {
  //     return true;
  // }

  // dragDropOnDrop(event, listEl, parentEl, newInputEl, inputEl) {
  //     return true;
  // }

  // onSupportError(parentEl, inputEl) {
  // }

  // beforeRender(parentEl, inputEl) {
  // }

  afterRender(listEl, parentEl, newInputEl, inputEl) {
    const plusInput = listEl.find('.fileuploader-thumbnails-input')
      .off("click")
      .on('click', () => this.api.open());
    this.api.getOptions().dragDrop.container = plusInput;

    eventProxy.emit("update-completeness-index");
  }

  // beforeSelect(files, listEl, parentEl, newInputEl, inputEl) {
  //     return true;
  // }

  // onFilesCheck(files, options, listEl, parentEl, newInputEl, inputEl) {
  //     return true;
  // }

  // onFileRead(item, listEl, parentEl, newInputEl, inputEl) {
  //     return true;
  // }

  onSelect(item, listEl, parentEl, newInputEl, inputEl) {
    item.data = {};
    switch (this.uploadType) {
      case 'video':
        this._uploadVideo(item);
        break;
      case 'document':
        this._uploadDocument(item);
        break;
      default:
        if (item.file.type.match(/^image\//)) {
          this._uploadImage(item);
        } else {
          item.upload.send();
        }
        break;
    }
  }

  async _uploadDocument(item) {
    const hash = await getFileHash(item.file);
    item.data.hash = hash;

    item.upload.send();

  }

  async _uploadVideo(item) {
    try {
      let duration = await getVideoDuration(item.file);
      duration = Math.max(1, Math.round(duration));
      item.data.duration = duration;
      // Maxiale Video-Länge Prüfen
      if (this.data.has('video-max-length') && (duration > this.data.get('video-max-length'))) {
        throw translate('tpWeb.global.fileuploader.error.videoLengthExceeded', {
          'max_length': this.data.get('video-max-length')
        });
      }
    } catch (ex) {
      console.error(ex);
      alert(ex);
      item.upload.cancel();
      return;
    }
    const hash = await getFileHash(item.file);
    item.data.hash = hash;
    item.upload.send();
  }

  get max_size() {
    return {
      height: this.element.dataset.maxHeight || 1200,
      width: this.element.dataset.maxWidth || 1920,
    }
  }

  async _uploadImage(item) {
    let startTime = Date.now();

    // 360°-Panorama-Bilder müssen im Seitenverhältnis 2:1 vorliegen (equirectangular)
    if (this.api.getOptions().upload.data.imageType === 'panorama') {
      const imagesize = await getImageSize(item.file);
      if (imagesize.width / imagesize.height !== 2) {
        alert(translate('tpWeb.global.fileuploader.error.aspectRatio', {
          'aspect_ratio': '2:1'
        }));
        item.upload.cancel();
        return;
      }
    }

    if (this.api.getOptions().upload.data.imageType !== 'panorama') {
      try {
        const originalFilesize = item.file.size;
        item.file = await scaleDownImage(item.file, this.max_size, item.type, 70);
        if (item.upload.formData) {
          // In formData auch setzen, weil Bilder < chunk-Size sonst im Original übertragen werden
          item.upload.formData.set('files[]', item.file);
        }
        item.data.scaleDownDuration = Date.now() - startTime;
        item.data.scaleDownSaved = Math.round((100 * 1 - (item.file.size / originalFilesize)));
      } catch (ex) {
        item.data.scaleDownImageFailed = ex.toString();
      }
    }
    item.upload.send();
  }


  async onRemove(item, listEl, parentEl, newInputEl, inputEl) {
    if (this.machine_id) {
      if (item.format == 'image' && item.data.file_id) {
        await this.ajaxCall({
          machine_id: this.machine_id,
          file_id: item.data.file_id,
          type: "remove"
        });
      } else if (item.format == 'video' && item.data.id) {
        await this.ajaxCall({
          machine_id: this.machine_id,
          video_id: item.data.id,
          type: "remove-video"
        });
      } else {
        await this.ajaxCall({
          machine_id: this.machine_id,
          document_id: item.data.id,
          type: "remove-document"
        });
      }
    }
    eventProxy.emit("update-completeness-index");
  }
}

function panoramaTemplate(data) {
  console.log('template', data);

  const content = `<div style="width: 100%; height: 100%" data-controller="panorama" data-panorama-src="${data.data.file || data.file}"></div>`;
  return `<div class="fileuploader-popup-preview">
            <div class="fileuploader-popup-node ${data.format}">
                ${content}
            </div>
            <div class="fileuploader-popup-content">
                <div class="fileuploader-popup-footer">
                    <ul class="fileuploader-popup-tools"></ul>
                </div>
                <div class="fileuploader-popup-header">
                    <ul class="fileuploader-popup-meta">
                        <li>
                            <span>${data.captions.name}:</span>
                            <h5>${data.name}</h5>
                        </li>
                        <li>
                            <span>${data.captions.type}:</span>
                            <h5>${data.extension.toUpperCase()}</h5>
                        </li>
                        <li>
                            <span>${data.captions.size}:</span>
                            <h5>${data.size2}</h5>
                        </li>
                        <li>
                            <span>${data.captions.dimensions}:</span>
                            <h5>${data.reader.width}x${data.reader.height}px</h5>
                        </li>
                    </ul>
                    <div class="fileuploader-popup-info"></div>
                    <ul class="fileuploader-popup-buttons">
                        <li><button class="fileuploader-popup-button" data-action="cancel">${data.captions.cancel}</a></li>
                    </ul>
                </div>
            </div>
        </div>`
}
